import { Component } from 'preact';
import styled from 'styled-components';


const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 125;
    top:0;
    right:-100%;
    background: ${props => props.theme.colors.backgroundDark2};
    padding: 20% 1em;
    transition-duration: 0.25s;
    transition-timing-function: ease-in-out;

    &.open {
        right: 0;
    }

    @media (min-width: 1200px) {
        width: 30vw;
    }
`
const Cross = styled.svg`
    fill: ${props => props.theme.colors.backgroundHighlight};
    width: 1em;
`

const CloseText = styled.p`
    font-weight: 400;
    font-size: 0.6em;
    margin: 0;
    color: ${props => props.theme.colors.backgroundHighlight};
    padding-top: 0.3em;
`

const CloseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 5em;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 4%;
    top: 0;
`
const Title = styled.h3`
    color: ${props => props.theme.colors.backgroundHighlight};
    font-weight: 800;
    font-size: 1.5em;
`
const Item = styled.li`
    padding: 0.8em 0;
    color: ${props => props.theme.colors.bodyHighlight};

    &.nested {
        font-size: 0.8em;
        padding-left: 1.2em;
    }
`
const Anchor = styled.a`
    text-decoration: none;
`

const ListWrapper = styled.ul`
    list-style: none;
    padding-left: 0em;
    height: 90%;
`
const MenuWrapper = styled.div`
    height: 100%;
    padding: 0 5% 0 10%;
`
const InnerWrapper = styled.div`
    opacity: 0;
    height: 100%;
    transition: 0.3s;
    transition-delay: 0.3s;

    &.open {
        opacity: 1;
    }
`
class SideMenu extends Component {


    render(props) {
        return (
            <Wrapper className={props.menuOpen ? 'open' : ''}>
                <InnerWrapper className={props.menuOpen ? 'open' : ''}>
                    <CloseWrapper onClick={props.toggleMenu}>
                        <Cross id="cross" data-name="cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><polygon points="0 3 3 0 45 42 87 0 90 3 48 45 90 87 87 90 45 48 3 90 0 87 42 45 0 3" /></Cross>
                        <CloseText>{props.content[0].closeLabel}</CloseText>
                    </CloseWrapper>

                    <MenuWrapper>
                        <Title>{props.content[0].heading}</Title>
                        <ListWrapper>
                            {props.content[0].links.map((link) => (

                                <Anchor href={link.url ? link.url : '#'} target={link.internalLink ? '' : "_blank"} onClick={props.toggleMenu}>
                                    <Item className={link.isSubLink ? 'nested' : ''}>
                                        {link.title}
                                    </Item>
                                </Anchor>
                            ))}
                        </ListWrapper>
                    </MenuWrapper>
                </InnerWrapper>
            </Wrapper>
        )
    }

}

export default SideMenu





// WEBPACK FOOTER //
// ./components/header/SideMenu.js